module.exports = __webpack_public_path__ + "static/media/notify.4fb00029.svg";